import { gql } from '@apollo/client';
import React from 'react';
import { ResponsiveImage } from '../../../../components/ResponsiveImage';
import { MobileLookviewVariantImageViewFragment } from '../../../../generated/types';

import './MobileLookviewVariantImageView.scss';

export const MOBILE_LOOKVIEW_VARIANT_IMAGE_VIEW_FRAGMENT = gql`
  fragment MobileLookviewVariantImageViewFragment on VariantData {
    primaryImage: primary_image_urls {
      src: medium
    }
    alternateImages: alternate_image_urls {
      src: medium
    }
  }
`;

interface Props {
  alt: string;
  variant: MobileLookviewVariantImageViewFragment;
}

export const MobileLookviewVariantImageView: React.FC<Props> = ({ alt, variant }) => (
  <div className="MobileLookviewVariantImageView">
    <ResponsiveImage
      className="MobileLookviewVariantImageView__image"
      maxWidth={775}
      maxHeight={1250}
      src={variant.primaryImage.src || '//:0'}
      alt={alt}
    />
  </div>
);
